import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Nav from "./components/nav/Nav";

export default function App() {
  return (
    <div className="App">
      <Nav />

      <Home />

      <Footer />
    </div>
  );
}